import evaluateAppMessage from './evaluateStepMessage/evaluateAppMessage.js';
import evaluateFlowControlMessage from './evaluateStepMessage/evaluateFlowControlMessage.js';
import evaluateGroupMessage from './evaluateStepMessage/evaluateGroupMessage.js';
import evaluateHttpRequestMessage from './evaluateStepMessage/evaluateHttpRequestMessage.js';
import evaluateIfElseMessage from './evaluateStepMessage/evaluateIfElseMessage.js';
import evaluateIterateMessage from './evaluateStepMessage/evaluateIterateMessage.js';
import evaluateMapMessage from './evaluateStepMessage/evaluateMapMessage.js';
import evaluateScheduleMessage from './evaluateStepMessage/evaluateScheduleMessage.js';
import evaluateWaitMessage from './evaluateStepMessage/evaluateWaitMessage.js';

const map = {
  schedule: evaluateScheduleMessage,
  appSelector: 'New Step',
  iterate: evaluateIterateMessage,
  ifElse: evaluateIfElseMessage,
  map: evaluateMapMessage,
  transform: 'Transform data source',
  flowControl: evaluateFlowControlMessage,
  httpRequest: evaluateHttpRequestMessage,
  runWorkflow: 'Run Workflow',
  triggerSelector: 'New Trigger',
  appTriggerSelector: 'On App Event',
  folder: 'New Folder',
  continue: 'Continue',
  webhook: 'Webhook',
  wait: evaluateWaitMessage,
  functionInputs: 'Function Inputs',
  groupResults: evaluateGroupMessage,
  memory: 'Set Memory',
  break: 'Break',
  default: evaluateAppMessage
};

export const evaluateStepMessage = async ({ app, step, workflow, apps, appsMetadata }) => {
  const slug = app?.slug;
  const params = { app, step, args: step?.arguments, workflow, apps, appsMetadata };
  let result;

  if (!slug) {
    result = map.default(params);
  } else {
    const messageMethod = map[slug];

    if (typeof messageMethod === 'string') {
      result = messageMethod;
    } else if (!messageMethod) {
      result = map.default(params);
    } else {
      result = slug === 'ifElse' ? await messageMethod(params) : messageMethod(params);
    }
  }

  return result;
};
